import styled from 'styled-components'

import { Button, TextInput } from '../../../components/ui'

export const Header = styled.header`
  margin-bottom: 34px;

  h1 {
    margin: 0;
    color: ${({ theme }) => theme.colors.text};
    font-size: clamp(1.8rem, 4vw, 2.25rem);
    line-height: 1.25;
    letter-spacing: -0.04em;

    span { white-space: nowrap; }
  }

  p { margin: 10px 0 0; color: ${({ theme }) => theme.colors.textMuted}; font-size: 0.93rem; line-height: 1.6; }
`

export const Form = styled.form`
  display: grid;
  gap: 20px;
`

export const Field = styled.label`
  display: grid;
  gap: 8px;
  color: ${({ theme }) => theme.colors.text};
  font-size: 0.84rem;
  font-weight: 680;
`

export const Input = styled(TextInput)`
  min-height: 50px;
  padding: 12px 14px;
  font-size: 1rem;
  border-color: ${({ $error, theme }) => $error ? theme.colors.danger : theme.colors.borderStrong};

  &:focus { border-color: ${({ $error, theme }) => $error ? theme.colors.danger : theme.colors.muiPrimary}; }
`

export const PasswordControl = styled.div`
  position: relative;
  ${Input} { padding-right: 48px; }
`

export const PasswordToggle = styled.button`
  position: absolute;
  top: 50%;
  right: 8px;
  display: grid;
  width: 36px;
  height: 36px;
  padding: 0;
  color: ${({ theme }) => theme.colors.textMuted};
  border: 0;
  border-radius: 50%;
  background: transparent;
  place-items: center;
  transform: translateY(-50%);

  svg { width: 19px; height: 19px; }
  &:hover { color: ${({ theme }) => theme.colors.text}; background: ${({ theme }) => theme.colors.primarySoft}; }
`

export const FieldError = styled.small`
  margin-top: -2px;
  color: ${({ theme }) => theme.colors.danger};
  font-size: 0.76rem;
  font-weight: 520;
`

export const ErrorNotice = styled.div`
  padding: 12px 14px;
  color: ${({ theme }) => theme.colors.danger};
  border: 1px solid ${({ theme }) => theme.colors.danger}38;
  border-radius: ${({ theme }) => theme.radius.small};
  background: ${({ theme }) => theme.colors.danger}0D;
  font-size: 0.82rem;
  line-height: 1.5;
`

export const SubmitButton = styled(Button)`
  width: 100%;
  min-height: 50px;
  margin-top: 4px;
  border-radius: ${({ theme }) => theme.radius.medium};
`

export const Assistance = styled.div`
  display: grid;
  grid-template-columns: 176px 76px;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
  margin-top: 24px;
  padding: 22px 28px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 0.82rem;

  a {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 0.84rem;
    font-weight: 700;
    line-height: 1.4;
    text-align: left;
  }
  a:hover { text-decoration: underline; text-underline-offset: 3px; }

  @media (max-width: 380px) {
    grid-template-columns: minmax(0, 176px) 76px;
    padding-inline: 0;
  }
`

export const SignUpRow = styled.p`
  display: grid;
  grid-template-columns: 176px 76px;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
  margin: 18px 0 0;
  padding-inline: 28px;
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 0.86rem;

  a {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 0.84rem;
    font-weight: 700;
    line-height: 1.4;
    text-align: left;
  }
  a:hover { text-decoration: underline; text-underline-offset: 3px; }

  @media (max-width: 380px) {
    grid-template-columns: minmax(0, 176px) 76px;
    padding-inline: 0;
  }
`
